import {KecPath, Service, Version, source} from './constants';


// 创建容灾组
export const createAvoid = {
    basePath: KecPath,
    params: {
        Action: 'CreateDataGuardGroup',
        Service,
        Version,
        source
    }
};


// 查询用户某区域的容灾分组容量
export const avoidCapacity = {
    basePath: KecPath,
    params: {
        Action: 'DescribeDataGuardCapacity',
        Service,
        Version,
        source
    }
};

// 删除容灾组
export const deleteAvoid = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DeleteDataGuardGroups',
        Service,
        Version,
        source
    }
};
// 查询（描述）获取容灾组信息
export const getAvoids = {
    basePath: KecPath,
    params: {
        Action: 'DescribeDataGuardGroup',
        Service,
        Version,
        source
    }
};

// 删除主机
export const removeInstance = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'RemoveVmFromDataGuard',
        Service,
        Version,
        source
    }
};

// 获取主机详情
export const GetInstanceByIds = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'GetInstanceByIds',
        Service,
        Version,
        source
    }
};

// 修改容灾组名称
export const editAvoid = {
    basePath: KecPath,
    params: {
        Action: 'ModifyDataGuardGroups',
        Service,
        Version,
        source
    }
};

// 查询荣在分组package
export const QueryAvoid = {
    basePath: KecPath,
    params: {
        Action: 'QueryDataGuardPackage',
        Service,
        Version,
        source
    }
};
